import { selectedProduct, productPrice } from "../utils/productPricing";
import React, { useEffect, useState, useRef } from "react";
import ProductDetailsSkeleton from "./ProductDetailsSkeleton";
import Headers from "../components/Headers";
import { normalizeStoreName } from "../utils/storeUtils";
import Footer from "../components/Footer";
import { Link, useParams, useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useDispatch, useSelector } from "react-redux";
import "swiper/css/pagination";
import { Pagination, Autoplay, Navigation } from "swiper";
import Ratings from "../components/Ratings";
import { AiFillHeart } from "react-icons/ai";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import Reviews from "../components/Reviews";
import { get_product, fetchStoreBySlug } from "../store/reducers/homeReducer";
import ShareButton from "./shareButton"
import { formatCurrency, fetchExchangeRates } from "../utils/currencyUtils";
import {
  add_to_card,
  messageClear,
  add_to_wishlist,
  get_cart_products,
  get_wishlist_products,
  remove_wishlist,
  delete_card_product,
} from "../store/reducers/cardReducer";
import api from "../api/api";
import toast from "react-hot-toast";
import {
  ChevronLeft,
  ChevronRight,
  Copy,
  Heart,
  MessageSquare,
  Minus,
  Package,
  Plus,
  Share,
  Share2,
  ShoppingBag,
} from "lucide-react";
import { Button } from "../components/ui/button";

const Details = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // Consolidate store context logic
  const { slug, storeName: urlStoreName, storename: altStoreName } = useParams();
  const outletContext = useOutletContext();
  const effectiveStoreParam = urlStoreName || altStoreName || outletContext?.storeName;
  const isStoreMode = outletContext?.isStoreMode || !!effectiveStoreParam; // Determine store mode reliably

  const storeToPass = effectiveStoreParam || location.state?.fromStore || (slug ? sessionStorage.getItem(`product-store-${slug}`) : null);
  const effectiveStore = storeToPass;

  const productSectionRef = useRef(null);
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [exchangeLoaded, setExchangeLoaded] = useState(false);
  const dispatch = useDispatch();
  const { seller, product, relatedProducts, moreProducts, error } = useSelector(
    (state) => state.home
  );
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, successMessage, card_products, wishlist } = useSelector((state) => state.card);

  const isProductInCart = (productId) => {
    if (!card_products) return false;
    return card_products.some(shop =>
      shop.products.some(item => item.productInfo._id === productId && (item.optionId || item.productInfo.selectedOptionId || "") === optionId)
    );
  };

  const isProductInWishlist = (productId) => {
    if (!wishlist) return false;
    return wishlist.some(item => item.productId === productId);
  };

  useEffect(() => {
    fetchExchangeRates().then(() => setExchangeLoaded(true));
  }, []);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (userInfo && userInfo.id) {
        try {
          const { data } = await api.get("/account/get-details");
          if (data.currency) {
            setCurrencyCode(data.currency);
          }
        } catch (error) {
          console.error("Error fetching user currency:", error);
        }
      }
    };
    fetchUserDetails();
  }, [userInfo]);

  const [image, setImage] = useState("");
  const [state, setState] = useState("description");
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mdtablet: {
      breakpoint: { max: 991, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 3,
    },
    smmobile: {
      breakpoint: { max: 640, min: 0 },
      items: 2,
    },
    xsmobile: {
      breakpoint: { max: 440, min: 0 },
      items: 1,
    },
  };

  const [quantity, setQuantity] = useState(1);

  const inc = () => {
    if (quantity >= product.stock) {
      toast.error("Out of stock");
    } else {
      setQuantity(quantity + 1);
    }
  };

  const dec = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const [optionId, setOptionId] = useState('');
  useEffect(() => { setOptionId(''); }, [product?._id]);
  const chosenProduct = selectedProduct(product, optionId);
  const add_card = () => {
    if (!chosenProduct) { toast.error('Choose a product option first'); return; }
    const cartItemId = card_products?.flatMap(shop => shop.products).find(item => item.productInfo._id === product._id && (item.optionId || item.productInfo.selectedOptionId || "") === optionId)?._id;
    if (cartItemId) {
      dispatch(delete_card_product({
        card_id: cartItemId,
        storeName: storeToPass
      }));
    } else {
      dispatch(
        add_to_card({
          userId: userInfo ? userInfo.id : null,
          quantity,
          productId: product._id,
          productInfo: chosenProduct,
          optionId,
          storeName: storeToPass
        })
      );
    }
  };

  const add_wishlist = () => {
    const existingWishlistItem = wishlist.find(item => item.productId === product._id);
    if (existingWishlistItem) {
      dispatch(remove_wishlist({
        wishlistId: existingWishlistItem._id,
        storeName: storeToPass
      }));
    } else {
      dispatch(
        add_to_wishlist({
          userId: userInfo ? userInfo.id : null,
          productId: product._id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          discount: product.discount,
          rating: product.rating,
          slug: product.slug,
          shopName: product.shopName || location.state?.fromStore,
          currency: product.currency,
          storeName: storeToPass
        })
      );
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        await dispatch(get_product(slug)).unwrap();
      } catch (err) {
        console.log('Error fetching product:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();

    // Only fetch store context here if NOT in StoreLayout (which handles it)
    // OR if we are in global mode but want to fetch store info for some reason
    if (effectiveStore && !isStoreMode) {
      dispatch(fetchStoreBySlug(effectiveStore));
    }
  }, [slug, effectiveStore, dispatch, isStoreMode]);

  useEffect(() => {
    if (!loading && productSectionRef.current) {
      productSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [loading]);

  useEffect(() => {
    if (errorMessage) {
      // toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (successMessage) {
      // toast.success(successMessage);
      dispatch(messageClear());
      if (userInfo) {
        if (storeToPass) {
          dispatch(get_cart_products({ userId: userInfo.id, storeName: storeToPass }));
          dispatch(get_wishlist_products({ userId: userInfo.id, storeName: storeToPass }));
        } else {
          dispatch(get_cart_products(userInfo.id));
          dispatch(get_wishlist_products(userInfo.id));
        }
      } else {
        if (storeToPass) {
          dispatch(get_cart_products({ userId: null, storeName: storeToPass }));
          dispatch(get_wishlist_products({ userId: null, storeName: storeToPass }));
        } else {
          dispatch(get_cart_products(null));
          dispatch(get_wishlist_products(null));
        }
      }
    }
  }, [errorMessage, successMessage, userInfo, dispatch, storeToPass]);

  const buy = () => {
    if (!chosenProduct) { toast.error('Choose a product option first'); return; }
    let price = chosenProduct.price;

    // Apply product discount if available
    if (product.discount !== 0) {
      price = chosenProduct.price - Math.floor((chosenProduct.price * product.discount) / 100);
    }

    // If there's an additional 5% discount, apply it (if necessary)
    let finalPrice = price; // Default to the computed price
    const applyExtraDiscount = false; // Change this to true if needed

    if (applyExtraDiscount) {
      finalPrice = price - Math.floor((price * 5) / 100);
    }

    const obj = [
      {
        sellerId: product.sellerId,
        shopName: product.shopName,
        price: quantity * finalPrice,
        products: [
          {
            quantity,
            productInfo: chosenProduct,
            optionId,
          },
        ],
      },
    ];

    console.log(obj[0].price);

    const shippingPath = storeToPass ? `/${storeToPass}/shipping` : "/shipping";
    navigate(shippingPath, {
      state: {
        products: obj,
        price: obj[0].price, // Ensure price is consistent
        items: 1,
        fromStore: storeToPass
      },
    });
  };

  // Theme logic - Only run if NOT in StoreMode (StoreLayout handles it otherwise)
  const getThemeClass = () => {
    if (isStoreMode) return ''; // Let layout handle it

    // 1. Fallback to store context if available in URL (Priority source)
    if (effectiveStore) {
      const normalizedStore = normalizeStoreName(effectiveStore);
      const cachedTheme = localStorage.getItem(`store-theme-${normalizedStore}`);

      // Check for cached custom theme settings
      try {
        const cachedSettings = localStorage.getItem(`store-settings-${normalizedStore}`);
        if (cachedSettings) {
          const settings = JSON.parse(cachedSettings);
          if (settings.useCustomTheme) return 'light-theme';
        }
      } catch (e) { }

      if (cachedTheme === 'light') return 'light-theme';
    }

    // 2. Then check Redux state (which might be populated by fetchStoreBySlug or get_product)
    const isActive = (obj) => obj && Object.keys(obj).length > 0;
    const activeSeller = isActive(seller) ? seller : (isActive(product?.sellerInfo) ? product.sellerInfo : null);
    const themeSettings = activeSeller?.themeSettings;
    const useCustomTheme = themeSettings?.useCustomTheme;

    if (useCustomTheme) {
      return 'light-theme';
    }

    if (activeSeller?.shopInfo?.theme === 'light') {
      return 'light-theme';
    }

    return '';
  };
  const themeClass = getThemeClass();

  // Theme Window Message Listener - Only if NOT StoreMode
  useEffect(() => {
    if (isStoreMode) return;
    const handleMessage = (event) => {
      if (event.data.type === 'UPDATE_PREVIEW') {
        const settings = event.data.seller?.themeSettings;
        if (settings) {
          const colors = settings.colors || {};
          const setVar = (name, value) => {
            if (value !== undefined && value !== null) document.body.style.setProperty(name, value);
          };

          const getContrastColor = (hexcolor) => {
            if (!hexcolor || hexcolor === 'transparent') return null;
            const hex = hexcolor.replace('#', '');
            const r = parseInt(hex.slice(0, 2), 16);
            const g = parseInt(hex.slice(2, 4), 16);
            const b = parseInt(hex.slice(4, 6), 16);
            const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
            return (yiq >= 128) ? '#000000' : '#ffffff';
          };
          const contrastColor = getContrastColor(colors.background);
          setVar('--store-bg', colors.background);
          setVar('--store-text', contrastColor);
          setVar('--store-icon', contrastColor);
          setVar('--store-button-bg', colors.buttonBg);
          setVar('--store-button-text', colors.buttonText);
          setVar('--store-product-card-bg', colors.productCardBg);
          setVar('--store-header-bg', colors.headerBg);
          setVar('--store-footer-bg', colors.footerBg);

          setVar('--store-input-bg', settings.inputs?.background || colors.inputBg);
          setVar('--store-input-text', settings.inputs?.text || colors.inputText);
          setVar('--store-input-border', settings.inputs?.border || colors.border);
          setVar('--store-input-border-width', `${settings.inputs?.borderWidth ?? 1}px`);
          setVar('--store-input-focus', settings.inputs?.focusRing || '#000000');
          setVar('--store-input-focus-width', `${settings.inputs?.focusWidth ?? 1}px`);
          setVar('--store-input-radius', `${settings.inputs?.radius || 20}px`);

          setVar('--store-select-bg', settings.selects?.background || colors.inputBg);
          setVar('--store-select-text', settings.selects?.text || colors.inputText);
          setVar('--store-select-border', settings.selects?.border || colors.border);
          setVar('--store-select-border-width', `${settings.selects?.borderWidth ?? 1}px`);
          setVar('--store-select-focus', settings.selects?.focusRing || '#000000');
          setVar('--store-select-focus-width', `${settings.selects?.focusWidth ?? 1}px`);
          setVar('--store-select-radius', `${settings.selects?.radius || 20}px`);
          // Inject/Update dynamic CSS for focus states
          const styleId = 'store-dynamic-focus-styles';
          let styleEl = document.getElementById(styleId);
          if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = styleId;
            document.head.appendChild(styleEl);
          }
          styleEl.innerHTML = `
            .store-input-focus:focus, .store-input-focus:focus-visible {
              outline: none !important;
              box-shadow: 0 0 0 var(--store-input-focus-width, 1px) var(--store-input-focus, #000) !important;
            }
            .store-select-focus:focus, .store-select-focus:focus-visible,
            .store-select-focus[data-state="open"] {
              outline: none !important;
              box-shadow: 0 0 0 var(--store-select-focus-width, 1px) var(--store-select-focus, #000) !important;
            }
          `;

          if (settings.typography?.fontFamily) {
            const fontFamily = settings.typography.fontFamily;
            const fontId = `google-font-${fontFamily.replace(/\s+/g, '-')}`;
            if (!document.getElementById(fontId)) {
              const link = document.createElement('link');
              link.id = fontId;
              link.rel = 'stylesheet';
              link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
              document.head.appendChild(link);
            }
            setVar('--store-font-family', `"${fontFamily}", sans-serif`);
          }
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [isStoreMode]);

  // Consolidated theme application logic (after component mounts/updates) - Only if NOT StoreMode
  useEffect(() => {
    if (isStoreMode) return;

    const isActive = (obj) => obj && Object.keys(obj).length > 0;
    const activeSeller = isActive(seller) ? seller : (isActive(product?.sellerInfo) ? product.sellerInfo : null);

    if (activeSeller?.shopInfo) {
      const themeSettings = activeSeller.themeSettings;
      const useCustomTheme = themeSettings?.useCustomTheme;
      const normalizedStore = effectiveStore ? normalizeStoreName(effectiveStore) : (activeSeller.shopInfo.shopName ? normalizeStoreName(activeSeller.shopInfo.shopName) : null);

      if (normalizedStore) {
        localStorage.setItem(`store-theme-${normalizedStore}`, activeSeller.shopInfo.theme);
        localStorage.setItem(`store-settings-${normalizedStore}`, JSON.stringify(themeSettings || {}));
        // Only update last visited store if we are actually in a store context
        if (effectiveStore) {
          localStorage.setItem('last-visited-store', effectiveStore);
        }
      }

      // Apply light-theme class
      if (useCustomTheme || activeSeller.shopInfo.theme === 'light') {
        document.body.classList.add('light-theme');
      } else {
        document.body.classList.remove('light-theme');
      }

      // Apply custom CSS variables
      if (useCustomTheme && themeSettings) {
        const colors = themeSettings.colors || {};
        const setVar = (name, value) => {
          if (value) document.body.style.setProperty(name, value);
        };

        const getContrastColor = (hexcolor) => {
          if (!hexcolor || hexcolor === 'transparent') return null;
          const hex = hexcolor.replace('#', '');
          const r = parseInt(hex.slice(0, 2), 16);
          const g = parseInt(hex.slice(2, 4), 16);
          const b = parseInt(hex.slice(4, 6), 16);
          const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
          return (yiq >= 128) ? '#000000' : '#ffffff';
        };

        const contrastColor = getContrastColor(colors.background);
        setVar('--store-bg', colors.background);
        setVar('--store-text', contrastColor);
        setVar('--store-icon', contrastColor);
        setVar('--store-button-bg', colors.buttonBg);
        setVar('--store-button-text', colors.buttonText);
        setVar('--store-product-card-bg', colors.productCardBg);
        setVar('--store-header-bg', colors.headerBg);
        setVar('--store-footer-bg', colors.footerBg);
        setVar('--store-input-bg', themeSettings.inputs?.background || colors.inputBg);
        setVar('--store-input-text', themeSettings.inputs?.text || colors.inputText);
        setVar('--store-input-border', themeSettings.inputs?.border || colors.inputBorder);
        setVar('--store-input-border-width', `${themeSettings.inputs?.borderWidth || 1}px`);
        setVar('--store-input-focus', themeSettings.inputs?.focusRing || '#000000');
        setVar('--store-input-focus-width', `${themeSettings.inputs?.focusWidth || 1}px`);
        setVar('--store-input-radius', `${themeSettings.inputs?.radius || 20}px`);
        setVar('--store-select-bg', themeSettings.selects?.background || colors.inputBg);
        setVar('--store-select-text', themeSettings.selects?.text || colors.inputText);
        setVar('--store-select-border', themeSettings.selects?.border || colors.inputBorder);
        setVar('--store-select-border-width', `${themeSettings.selects?.borderWidth || 1}px`);
        setVar('--store-select-focus', themeSettings.selects?.focusRing || '#000000');
        setVar('--store-select-focus-width', `${themeSettings.selects?.focusWidth || 1}px`);
        setVar('--store-select-radius', `${themeSettings.selects?.radius || 20}px`);
        setVar('--store-border', colors.border);
        setVar('--store-muted', colors.muted);
        setVar('--store-glass', colors.glass);

        // Inject/Update dynamic CSS for focus states
        const styleId = 'store-dynamic-focus-styles';
        let styleEl = document.getElementById(styleId);
        if (!styleEl) {
          styleEl = document.createElement('style');
          styleEl.id = styleId;
          document.head.appendChild(styleEl);
        }
        styleEl.innerHTML = `
          .store-input-focus:focus, .store-input-focus:focus-visible {
            outline: none !important;
            box-shadow: 0 0 0 var(--store-input-focus-width, 1px) var(--store-input-focus, #000) !important;
          }
          .store-select-focus:focus, .store-select-focus:focus-visible,
          .store-select-focus[data-state="open"] {
            outline: none !important;
            box-shadow: 0 0 0 var(--store-select-focus-width, 1px) var(--store-select-focus, #000) !important;
          }
        `;

        if (themeSettings.typography?.fontFamily) {
          const fontFamily = themeSettings.typography.fontFamily;
          const fontId = `google-font-${fontFamily.replace(/\s+/g, '-')}`;
          if (!document.getElementById(fontId)) {
            const link = document.createElement('link');
            link.id = fontId;
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
            document.head.appendChild(link);
          }
          setVar('--store-font-family', `"${fontFamily}", sans-serif`);
        }
      }
    }
  }, [seller, product?.sellerInfo, effectiveStore, isStoreMode]);

  if (loading) {
    return (
      <div className={`min-h-screen bg-[var(--store-bg)] ${!isStoreMode ? themeClass : ''}`}>
        {!isStoreMode && <Headers storeName={effectiveStore} />}
        <ProductDetailsSkeleton />
        {!isStoreMode && <Footer />}
      </div>
    );
  }

  if (errorMessage || !product || Object.keys(product).length === 0) {
    return (
      <div className={!isStoreMode ? themeClass : ''}>
        {!isStoreMode && <Headers storeName={effectiveStore} />}
        <div className="min-h-screen bg-[var(--store-bg)]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] mx-auto py-24">
            <div className="flex flex-col items-center justify-center gap-6 text-center">
              <Package className="w-16 h-16 text-[var(--store-muted)]" />
              <h1 className="text-3xl font-bold text-[var(--store-text)]">Product Not Available</h1>
              <p className="text-[var(--store-muted)] max-w-md">
                Sorry, the product you're looking for is currently not available or may have been removed.
              </p>
              <div className="flex items-center gap-2 text-[var(--store-muted)]">
                <Link to={location.state?.fromStore ? `/${location.state.fromStore}` : "/"} className="text-[var(--store-text)] hover:text-green-500 transition-colors">
                  Return to Home
                </Link>
                <ChevronRight size={16} />
                <Link to="/products" className="text-[var(--store-text)] hover:text-green-500 transition-colors">
                  Browse Products
                </Link>
              </div>
            </div>
          </div>
        </div>
        {!isStoreMode && <Footer />}
      </div>
    )
  }

  return (
    <div className={`min-h-screen bg-[var(--store-bg)] transition-colors duration-300 ${!isStoreMode ? themeClass : ''}`}>
      {!isStoreMode && <Headers storeName={effectiveStore || product?.shopName} />}
      <div
        className="h-[220px] bg-cover bg-no-repeat relative bg-left"
        style={{
          backgroundImage: `url(${product?.banner?.banner
            ? product.banner.banner
            : `${process.env.REACT_APP_URL}/images/banner/bannermain.jpg`
            })`,
        }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#0000008a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className={`${product.name.length > 30 ? 'text-xl' : 'text-3xl'} font-bold text-center px-4`}>{product.name}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[var(--store-product-card-bg)] py-5 mb-5">
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="flex justify-start items-center text-md text-[var(--store-muted)] w-full">
            <Link to={location.state?.fromStore ? `/${location.state.fromStore}` : "/"}>Home</Link>
            <span className="">
              <ChevronRight size={18} />
            </span>
            <Link to={`/products?category=${product.category}`}>
              {product.category}
            </Link>
            <span className="">
              <ChevronRight size={18} />
            </span>
            <span className="text-[var(--store-text)]" title={product.name}>
              {product.name.length > 50 ? `${product.name.slice(0, 50)}...` : product.name}
            </span>
          </div>
        </div>
      </div>
      <section ref={productSectionRef}>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="grid grid-cols-2 md-lg:grid-cols-1 gap-8">
            <div>
              <div className="relative">
                {isProductInCart(product._id) && (
                  <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-[#FFE11B] font-semibold text-xs right-2 top-2 z-10 shadow-lg transition-all duration-500">
                    <ShoppingBag size={20} className="text-black" />
                  </div>
                )}
                <img
                  className="nex_img_cover sm:h-[300px] h-[400px] w-full"
                  src={image ? image : product.images?.[0]}
                  alt=""
                />
              </div>
              <div className="py-3">
                {product.images && (
                  <Carousel
                    autoPlay={true}
                    infinite={true}
                    responsive={responsive}
                    transitionDuration={500}
                  >
                    {product.images.map((img, i) => {
                      return (
                        <div
                          key={i}
                          className="px-2 w-full"
                          onClick={() => setImage(img)}
                        >
                          <img
                            className="nex_img_cover cursor-pointer  nex_border_sm"
                            src={img}
                            alt=""
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                )}
              </div>
            </div>
            <div className="flex flex-col gap-5">
              <div className="text-3xl text-[var(--store-text)] font-bold">
                <h2>{product.name}</h2>
              </div>
              <Link to={`/${product.shopName}`} className="flex items-center text-[var(--store-text)] hover:text-green-500 transition-colors w-fit">
                From {product.shopName} <Package className="ml-2" size="18" />{" "}
              </Link>
              <div className="flex justify-start items-center gap-4">
                <div className="flex text-xl">
                  <Ratings ratings={product.rating} />
                </div>
              </div>

              <div className="text-2xl text-green-500 font-bold flex gap-3">
                {product.discount !== 0 ? (
                  <>
                    <h2>
                      {" "}
                      {productPrice(chosenProduct || product, currencyCode)}
                    </h2>
                    <h2 className="line-through text-[var(--store-muted)]">
                      {productPrice({ ...(chosenProduct || product), discount: 0 }, currencyCode)}

                    </h2>
                  </>
                ) : (
                  <h2>Price : {productPrice(chosenProduct || product, currencyCode)}</h2>
                )}
              </div>
              <div className="text-[var(--store-text)]">
                <p className="whitespace-pre-wrap break-words">{product.description}</p>
              </div>
              <div className="flex flex-wrap gap-3 pb-10 items-center">
                {!!product.priceOptions?.length && <label className="block w-full my-4 font-medium">Choose an option
                  <select aria-label="Choose a product option" className="block w-full border rounded p-3 mt-2 bg-[var(--store-background)]" value={optionId} onChange={e => setOptionId(e.target.value)}>
                    <option value="">Select an option</option>
                    {product.priceOptions.map(o => <option key={o.id} value={o.id}>{o.label} — {productPrice({ ...product, price: o.price, selectedOptionId: o.id }, currencyCode)}</option>)}
                  </select>
                </label>}
                {product.stock ? (
                  <>
                    <div className="flex bg-[var(--store-card-bg)] text-[var(--store-text)] rounded-[30px] h-[40px] justify-center items-center text-xl">
                      <div onClick={dec} className="px-6 cursor-pointer">
                        <Minus size={18} />
                      </div>
                      <div className="px-5">{quantity}</div>
                      <div onClick={inc} className="px-6 cursor-pointer">
                        <Plus size={18} />
                      </div>
                    </div>
                    <div>
                      <Button onClick={add_card} className={`h-[40px] bg-[var(--store-button-bg)] text-[var(--store-button-text)] hover:bg-[var(--store-button-bg)] hover:opacity-90 ${isProductInCart(product._id) ? ' ' : ''}`}>
                        {isProductInCart(product._id) ? 'Remove from cart' : 'Add to cart'}
                        {isProductInCart(product._id) ? <Minus className="ml-2" size={24} /> : ''}
                      </Button>
                    </div>
                  </>
                ) : (
                  ""
                )}

                <div onClick={add_wishlist} className="w-[38px] h-[38px] cursor-pointer rounded-full flex justify-center items-center bg-[var(--store-glass)] backdrop-blur-md border border-[var(--store-border)] hover:bg-[var(--store-glass)] transition-all">
                  <Heart size={20} className={`${isProductInWishlist(product._id) ? 'fill-red-500 text-red-500' : 'text-[var(--store-text)]'}`} />
                </div>
              </div>
              <div className="flex py-5 gap-5">
                <div className="w-[150px] text-[var(--store-text)] text-xl flex flex-col gap-5">
                  <span>Availability</span>
                  <span>Share</span>
                </div>
                <div className="flex flex-col gap-5">
                  <span
                    className={`text-${product.stock ? "green" : "red"}-500`}
                  >
                    {product.stock
                      ? `In Stock(${product.stock})`
                      : "Out of Stock"}
                  </span>
                  <ul>
                    <ShareButton />
                  </ul>
                </div>
              </div>
              <div className="flex gap-3">
                {product.stock ? (
                  <button
                    onClick={buy}
                    className="flex items-center bg-[var(--store-text)] nex_button button_200 font-semibold text-[var(--store-bg)] hover:opacity-90 h-[40px]"
                  >
                    Buy Now <ShoppingBag size={20} className="ml-2" />{" "}
                  </button>
                ) : (
                  ""
                )}
                {!storeToPass && !sessionStorage.getItem(`product-store-${slug}`) && (
                  <Link to={`/dashboard/chat/${product.sellerId}`} className="">
                    <button className="flex items-center nex_button font-semibold text-[var(--store-text)] hover:bg-[var(--store-card-bg)] hover:text-[var(--store-text)] h-[40px]">
                      Chat seller <MessageSquare size={20} className="ml-2" />{" "}
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="flex flex-wrap">
            <div className="w-[72%] md-lg:w-full">
              <div className="pr-4 md-lg:pr-0">
                <div className="grid grid-cols-2">
                  <button
                    onClick={() => setState("description")}
                    className={` px-5 py-3 hover:text-[var(--store-text)] font-bold rounded-full  ${state === "description" ? "text-[var(--store-text)] bg-[var(--store-card-bg)]" : "text-[var(--store-muted)]"
                      } `}
                  >
                    Description
                  </button>
                  <button
                    onClick={() => setState("reviews")}
                    className={`rounded-full hover:text-[var(--store-text)] px-5  py-3 font-bold  ${state === "reviews" ? " text-[var(--store-text)] bg-[var(--store-card-bg)]" : "text-[var(--store-muted)]"
                      } `}
                  >
                    Reviews
                  </button>
                </div>
                <div>
                  {state === "reviews" ? (
                    <Reviews product={product} />
                  ) : (
                    <p className="py-5 text-[var(--store-text)] whitespace-pre-wrap break-words">{product.description}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="w-[28%] md-lg:w-full">
              <div className="pl-4 md-lg:pl-0">
                <div className="sm:px-0 px-3 text-[var(--store-text)]">
                  <Link to={`/${product.shopName}`} className="flex items-center justify-end hover:text-green-500 transition-colors">
                    {" "}
                    More from {product.shopName}{" "}
                    <Package className="ml-2" size="18" />
                  </Link>
                </div>
                <div className="flex flex-col gap-5 mt-3 p-3 sm:p-0">
                  {moreProducts.length === 0 ? (
                    <p className="text-sm font-bold text-[var(--store-muted)]">
                      No more products from this shop
                    </p>
                  ) : (
                    moreProducts.map((p, i) => {
                      return (
                        <Link
                          className="block bg-[var(--store-product-card-bg)]"
                          to={p.shopName ? `/${p.shopName}/product/details/${p._id}` : `/product/details/${p._id}`}
                          state={{ fromStore: storeToPass }}
                          key={i}
                        >
                          <div className="relative h-[270px]">
                            <img
                              className="w-full h-full nex_img_cover"
                              src={p.images[0]}
                              alt={p.name}
                            />
                            {p.discount !== 0 && (
                              <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-red-600 font-semibold text-s left-2 top-2">
                                {p.discount}%
                              </div>
                            )}
                          </div>
                          <h2 className="text-[var(--store-text)] pt-4 px-2">{p.name}</h2>
                          <div className="flex gap-2 px-2">
                            <h2 className="text-[var(--store-text)] text-lg font-bold">
                              {productPrice(p, currencyCode)}
                            </h2>
                            <div className="flex items-center gap-2">
                              <Ratings ratings={p.rating} />
                            </div>
                          </div>
                        </Link>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <h2 className="text-xl py-8 text-[var(--store-text)]">Related Products</h2>
          <div className="relative group">
            <div className="absolute top-1/2 -left-4 z-10 -translate-y-1/2 pointer-events-none">
              <button className="custom-prev-button pointer-events-auto w-12 h-12 flex items-center justify-center rounded-full bg-[var(--store-glass)] backdrop-blur-md border border-[var(--store-border)] text-[var(--store-text)] hover:bg-[var(--store-glass)] transition-all shadow-lg">
                <ChevronLeft size={24} />
              </button>
            </div>

            <div className="absolute top-1/2 -right-4 z-10 -translate-y-1/2 pointer-events-none">
              <button className="custom-next-button pointer-events-auto w-12 h-12 flex items-center justify-center rounded-full bg-[var(--store-glass)] backdrop-blur-md border border-[var(--store-border)] text-[var(--store-text)] hover:bg-[var(--store-glass)] transition-all shadow-lg">
                <ChevronRight size={24} />
              </button>
            </div>

            <Swiper
              slidesPerView="auto"
              breakpoints={{
                1280: {
                  slidesPerView: 3,
                },
                565: {
                  slidesPerView: 2,
                },
              }}
              spaceBetween={25}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              navigation={{
                nextEl: '.custom-next-button',
                prevEl: '.custom-prev-button',
              }}
              modules={[Autoplay, Navigation]}
              className="mySwiper"
            >
              {relatedProducts.map((p, i) => {
                return (
                  <SwiperSlide key={i}>
                    <Link className="block bg-[var(--store-product-card-bg)]" to={p.shopName ? `/${p.shopName}/product/details/${p._id}` : `/product/details/${p._id}`} state={{ fromStore: storeToPass }}>
                      <div className="relative h-[270px] ">
                        <div className="w-full h-full">
                          <img
                            className="w-full h-full nex_img_cover"
                            src={p.images[0]}
                          />
                        </div>
                        {p.discount !== 0 && (
                          <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-red-600 font-semibold text-s left-2 top-2">
                            {p.discount}%
                          </div>
                        )}
                      </div>
                      <div className="pt-4 flex flex-col gap-1 px-2">
                        <h2 className="text-[var(--store-text)]">{p.name}</h2>
                        <div className="flex justify-start items-center gap-3">
                          <h2 className="text-lg font-bold text-[var(--store-text)]">{productPrice(p, currencyCode)}</h2>
                          <div className="flex">
                            <Ratings ratings={p.rating} />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </section>
      {!isStoreMode && <Footer />}
    </div>
  );
};

export default Details;
